var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.$objectViewRoute(_vm.object)}},[_vm._v(" "+_vm._s(_vm.$objectDenomination(_vm.object))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }